import image1 from './Rectangle 2.1.jpg';
import image2 from './Rectangle 2.jpg';

export const dataCurators = [
  {
    img: image1,
    about: [
      'Сергей Евгеньевич Нарышкин,',
      'Председатель Российского исторического общества'
    ],
    greeting: [
      'Дорогие друзья!',
      'Российские библиотеки хранят в своих фондах колоссальное интеллектуальное наследие. И сегодня, когда значительная его часть уже оцифрована, перед нами встаёт вопрос об обеспечении доступности этих источников для широкого круга исследователей.',
      'Современные интернет-технологии позволяют упростить процесс поиска необходимых исторических сведений. Хорошим примером здесь служит портал «Сводный указатель личных имен в дореволюционной периодике», разработанный Правительством Москвы под эгидой Российского исторического общества. Это – уникальная электронная база данных, созданная на основе ежемесячного дореволюционного журнала «Русская старина».',
      'Теперь и у профессиональных исследователей, и у всех любителей нашего прошлого появился удобный поисковый инструмент, позволяющий комфортно работать с конкретным историческим источником, а также находить ранее неизвестные связи между различными историческими персоналиями.',
      'Уверен, работа на портале не только принесёт пользователям большое интеллектуальное удовольствие, но и позволит им совершать новые исторические открытия.'
    ]
  },
  {
    img: image2,
    about: [
      'Александр Владимирович Кибовский,',
      'Министр Правительства Москвы, руководитель Департамента культуры города Москвы'
    ],
    greeting: [
      'Дорогие друзья!',
      'Рад представить вам проект «Сводный указатель личных имен в дореволюционной периодике», в котором собраны имена, упомянутые в периодическом издании «Русская старина» за 1870–1917 годы. Этот проект станет первым ресурсом, систематизирующим сразу несколько указателей XIX – начала XX веков.',
      'Проект сводного указателя даст возможность с помощью информационных технологий среди большого объема информации найти и идентифицировать необходимого человека или сведения о нем. Более глубокое погружение – до каждой фамилии, от императоров и членов царской фамилии до рядовых купцов и крестьян – поможет увидеть, что каждый человек важен для истории Отечества.',
      'Уверен, проект станет подарком не только для заинтересованных в истории граждан, но и для профессиональных историков, у которых появится возможность узнать о судьбах людей, почти незаметных с точки зрения «большой» истории. '
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/Curators/dataCurators.js